import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/atoms/Badge';
import { Spinner } from '@/components/atoms/Spinner';
import { KeyValueTable } from '@/components/organisms/DataTable';
import type { Version } from '@/domain/bioscopes';
import { formatDateTimeWorded } from '@/utils/date';

import styles from './BioscopeMeta.module.scss';

interface BioscopeMetaProps {
    title?: string;
    isLoading: boolean;
    bioscopeMetaData: Version;
}

function BioscopeMeta({
    title = 'molecules.bioscopeMeta.meta',
    isLoading,
    bioscopeMetaData,
}: BioscopeMetaProps) {
    const { t } = useTranslation();
    let recordingVersion: string | undefined;
    let processingVersion: string | undefined;
    if (bioscopeMetaData?.version) {
        const matches = bioscopeMetaData.version.match(/v?\d.*/g);
        if (matches) {
            [recordingVersion, processingVersion] = matches;
        }
    }

    return (
        <div className={styles.bioscopeMeta}>
            <h2>{t(title)}</h2>
            {isLoading ? (
                <Spinner size="lg" />
            ) : (
                <div className={styles.section}>
                    <KeyValueTable
                        rows={[
                            {
                                key: 'version',
                                label: t('molecules.bioscopeMeta.version'),
                                value: (
                                    <>
                                        (
                                        {bioscopeMetaData?.version
                                            ? formatDateTimeWorded(
                                                  bioscopeMetaData.updatedAt,
                                                  'minute'
                                              )
                                            : t('molecules.common.neverUpdated')}
                                        )
                                    </>
                                ),
                            },
                            ...(bioscopeMetaData?.version
                                ? [
                                      {
                                          key: 'recording',
                                          label: t('bioscopeDetail.meta.recording'),
                                          value: <Badge>{recordingVersion}</Badge>,
                                      },
                                      {
                                          key: 'processing',
                                          label: t('bioscopeDetail.meta.processing'),
                                          value: <Badge>{processingVersion}</Badge>,
                                      },
                                  ]
                                : []),
                        ]}
                    />
                </div>
            )}
        </div>
    );
}

export default BioscopeMeta;
export { BioscopeMeta };
